import { Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FrontOfficeEnergySourceResolverService {
  resolve(route: ActivatedRouteSnapshot) {
    if (route.parent.parent.url.find((x) => x.path.indexOf('gas') > -1)) {
      return 'GAS';
    }

    return 'POWER';
  }
}
